import { render, staticRenderFns } from "./customerPage.vue?vue&type=template&id=df910b22&scoped=true&"
import script from "./customerPage.vue?vue&type=script&lang=js&"
export * from "./customerPage.vue?vue&type=script&lang=js&"
import style0 from "./customerPage.vue?vue&type=style&index=0&id=df910b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df910b22",
  null
  
)

export default component.exports